var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.334 44H34.334C40.334 44 44.334 40 44.334 34V24C44.334 18.6 40.934 14.6 35.934 14C35.534 14 34.934 14 34.334 14H14.334C13.734 14 13.334 14 12.734 14.2C7.53398 14.8 4.33398 18.6 4.33398 24C4.33398 24.6 4.33398 25.4 4.33398 26",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.9344 13.9999C35.5344 13.9999 34.9344 13.9999 34.3344 13.9999H14.3344C13.7344 13.9999 13.3344 13.9999 12.7344 14.1999C12.9344 13.5999 13.3344 13.1999 13.9344 12.5999L20.3344 5.9999C23.1344 3.1999 27.5344 3.1999 30.3344 5.9999L33.9344 9.59988C35.1344 10.7999 35.7344 12.3999 35.9344 13.9999Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.334 25H38.334C36.134 25 34.334 26.8 34.334 29C34.334 31.2 36.134 33 38.334 33H44.334",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9332 42.8C15.4732 42.8 18.3332 39.94 18.3332 36.4C18.3332 32.86 15.4732 30 11.9332 30C8.39321 30 5.5332 32.86 5.5332 36.4C5.5332 39.94 8.39321 42.8 11.9332 42.8Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 44L6.33398 42",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSearch);
export default __webpack_public_path__ + "static/media/wallet-search.b7130bf076de1e3aeb8fb8092a16fcda.svg";
export { ForwardRef as ReactComponent };